export const REMOTE_USERS_QUERY_KEY = 'remoteUsers';
